const LAST_SELECTED_SITE_KEY = "qo_connect_last_selected_site";

export function getLastSelectedSiteId(): string | null {
  try {
    return localStorage.getItem(LAST_SELECTED_SITE_KEY);
  } catch {
    return null;
  }
}

export function setLastSelectedSiteId(siteId: string): void {
  try {
    localStorage.setItem(LAST_SELECTED_SITE_KEY, siteId);
  } catch (error) {
    console.error("Error saving last selected site", error);
  }
}

export function clearLastSelectedSiteId(): void {
  try {
    localStorage.removeItem(LAST_SELECTED_SITE_KEY);
  } catch (error) {
    console.error("Error clearing last selected site", error);
  }
}

export function resolveCurrentSiteId(
  sites: readonly { id: string; name: string }[],
): string | undefined {
  const lastSelectedSiteId = getLastSelectedSiteId();
  if (
    lastSelectedSiteId &&
    sites.some((site) => site.id === lastSelectedSiteId)
  )
    return lastSelectedSiteId;
  return [...sites].sort((a, b) => a.name.localeCompare(b.name))[0]?.id;
}
